<template>
<div class="chapter">
<div class="inner_page">
<p class="P_WFP_ChapHead" id="auto_bookmark_table_of_contents_1"><span>The Coming American</span></p>
<p class="P_WFP_Quote">Bring me men to match my mountains,</p>
<p class="P_WFP_Quote">Bring me men to match my plains.</p>
<p class="P_WFP_Quote">Men to chart a starry empire,</p>
<p class="P_WFP_Quote">Men to make celestial claims …</p>
<p class="P_WFP_QuoteByLine">Samuel Walter Foss<br/>(At the base of the ramp leading to the USAFA<br/>cadet area from 1958—2003)</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// section0009.vue?46a9b70e